<script setup lang="ts">
import { Menu, MenuButton, MenuItems } from '@headlessui/vue';
import type { HTMLAttributes } from 'vue';

defineProps<{
  itemsClass?: HTMLAttributes['class'],
  btnAriaLabel?: string,
  buttonCy?: string,
}>();
</script>
<template>
  <Menu as="div" class="relative text-left">
    <MenuButton
      :class="[
        'w-full',
        'focus:outline-none focus-visible:ring-2',
        'focus-visible:ring(--ui-primary) focus-visible:ring-opacity-75',
      ]"
      :aria-label="btnAriaLabel"
      :data-cy="buttonCy"
    >
      <slot name="title" />
    </MenuButton>
    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <MenuItems
        :class="[
          'absolute',
          'shadow-lg rounded-lg overflow-hidden',
          'divide-y dark:divide-slate-600',
          itemsClass,
        ]"
      >
        <slot name="items" />
      </MenuItems>
    </transition>
  </Menu>
</template>
